import TokensService from '@omni/kit/services/TokensService';

import BaseService, { IHttpResponse } from '../BaseService';
import { cache } from './Cache';
import { IPrepareHitsUrl, prepareHitsUrl } from './PrepareHitsUrl';
import { ISearchResults } from './SearchTypes';

const debug = require('debug')('tca:service:SearchService');

interface ISearch extends IPrepareHitsUrl {
  getFromCache?: boolean;
}

export interface ISearchResponse extends IHttpResponse {
  body?: ISearchResults;
}

export const search = async ({
  getFromCache,
  token,
  ...buildUrlProps
}: ISearch): Promise<ISearchResponse> => {
  debug('search');
  const url = prepareHitsUrl(buildUrlProps);

  const guestToken = await TokensService.getGuestToken();

  return BaseService.Get({
    url,
    getFromCache,
    skipTimestamp: true,
    cache,
    token: token ? token : guestToken,
  });
};
